import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { useSelector } from '@lumapps/redux/react';
import { useTranslate } from '@lumapps/translations';

import { isLumappsApplicationIdentityEnabled } from '../../ducks/selectors';
import { LUMAPPS_APPLICATIONS } from '../../keys';
import { lumappsApplicationsRoute } from '../../routes';

export type ApplicationsSideNavigationProps = Partial<SideNavigationItemProps>;

/**
 * Side nav item for the LumApps Applications page, rendered under Provider settings.
 * Only visible when the `lumapps-application-identity` feature flag is enabled.
 *
 * @returns ApplicationsSideNavigation
 */
export const ApplicationsSideNavigation: React.FC<ApplicationsSideNavigationProps> = (props) => {
    const { translateKey } = useTranslate();
    const isAllowed = useSelector(isLumappsApplicationIdentityEnabled);

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...props}
            label={translateKey(LUMAPPS_APPLICATIONS.NAME)}
            route={lumappsApplicationsRoute}
        />
    );
};

ApplicationsSideNavigation.displayName = 'SideNavigationItem';
